import { useEffect, useState } from 'react'
import { getToken } from '@cinch-labs/shared-util'
import { Env, readFromEnv } from '@cinch-nx/environments'
import {
  getOwnerships,
  identifyNonCinchOwnership,
} from '../services/vehicle-ownership/vehicle-ownership-service'
import { IdentifyNonCinchOwnershipRequest } from '../services/vehicle-ownership/types'

export const useAddNonCinchOwnership = (
  vehicle: IdentifyNonCinchOwnershipRequest | undefined,
) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    const token = getToken({
      authKey: readFromEnv(Env.AuthKey),
      legacyAuthKey: readFromEnv(Env.LegacyAuthKey),
    })

    if (!token?.access_token || !vehicle) {
      return
    }

    const syncOwnership = async () => {
      setLoading(true)
      setError(false)

      try {
        const result = await getOwnerships(token)

        if (result.error || !result.ownerships) {
          setError(true)
          return
        }

        const alreadyExists = result.ownerships.some(
          (ownership) => ownership.vehicle.vin === vehicle.vin,
        )

        if (!alreadyExists) {
          await identifyNonCinchOwnership(token, vehicle)
        }
      } catch {
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    syncOwnership()
  }, [vehicle?.vin])

  return { loading, error }
}
